/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './HubSpotVideoRpc';
import * as Queries from './HubSpotVideoRpc.dfc.new';
import type { AdditionalContextArgs } from './HubSpotVideoRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetVideoByVideoIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetVideoByVideoIdResponseType>,
    References.GetVideoByVideoIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getVideoByVideoId', References.GetVideoByVideoIdResponseType>
        : References.GetVideoByVideoIdResponseType)
    | undefined;
};

export function useGetVideoByVideoIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideoByVideoIdResponseType>,
    References.GetVideoByVideoIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByVideoIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEO_BY_VIDEO_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoByVideoId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoByVideoIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetVideoByVideoIdQueryReturn<T>;
}

type UseGetVideoByVideoIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideoByVideoIdResponseType>,
    References.GetVideoByVideoIdRequestType,
    T extends true
      ? Record<'getVideoByVideoId', References.GetVideoByVideoIdResponseType>
      : References.GetVideoByVideoIdResponseType
  >;

export function useGetVideoByVideoIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideoByVideoIdResponseType>,
    References.GetVideoByVideoIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByVideoIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEO_BY_VIDEO_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoByVideoId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideoByVideoIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideoByVideoIdLazyQueryReturn<T>;
}

type UseGetVideoByVideoIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetVideoByVideoIdResponseType>,
    References.GetVideoByVideoIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getVideoByVideoId', References.GetVideoByVideoIdResponseType>
    : References.GetVideoByVideoIdResponseType;
};

export function useGetVideoByVideoIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideoByVideoIdResponseType>,
    References.GetVideoByVideoIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByVideoIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEO_BY_VIDEO_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideoByVideoId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoByVideoIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideoByVideoIdSuspenseQueryReturn<T>;
}

type UseGetCrmVideoByVideoIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetCrmVideoByVideoIdResponseType>,
    References.GetCrmVideoByVideoIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getCrmVideoByVideoId',
            References.GetCrmVideoByVideoIdResponseType
          >
        : References.GetCrmVideoByVideoIdResponseType)
    | undefined;
};

export function useGetCrmVideoByVideoIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetCrmVideoByVideoIdResponseType>,
    References.GetCrmVideoByVideoIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetCrmVideoByVideoIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_CRM_VIDEO_BY_VIDEO_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getCrmVideoByVideoId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetCrmVideoByVideoIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetCrmVideoByVideoIdQueryReturn<T>;
}

type UseGetCrmVideoByVideoIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetCrmVideoByVideoIdResponseType>,
    References.GetCrmVideoByVideoIdRequestType,
    T extends true
      ? Record<
          'getCrmVideoByVideoId',
          References.GetCrmVideoByVideoIdResponseType
        >
      : References.GetCrmVideoByVideoIdResponseType
  >;

export function useGetCrmVideoByVideoIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetCrmVideoByVideoIdResponseType>,
    References.GetCrmVideoByVideoIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetCrmVideoByVideoIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_CRM_VIDEO_BY_VIDEO_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getCrmVideoByVideoId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetCrmVideoByVideoIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetCrmVideoByVideoIdLazyQueryReturn<T>;
}

type UseGetCrmVideoByVideoIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetCrmVideoByVideoIdResponseType>,
    References.GetCrmVideoByVideoIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getCrmVideoByVideoId',
        References.GetCrmVideoByVideoIdResponseType
      >
    : References.GetCrmVideoByVideoIdResponseType;
};

export function useGetCrmVideoByVideoIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetCrmVideoByVideoIdResponseType>,
    References.GetCrmVideoByVideoIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetCrmVideoByVideoIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_CRM_VIDEO_BY_VIDEO_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getCrmVideoByVideoId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetCrmVideoByVideoIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetCrmVideoByVideoIdSuspenseQueryReturn<T>;
}

type UseGetVideosByVideoIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetVideosByVideoIdsResponseType>,
    References.GetVideosByVideoIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getVideosByVideoIds',
            References.GetVideosByVideoIdsResponseType
          >
        : References.GetVideosByVideoIdsResponseType)
    | undefined;
};

export function useGetVideosByVideoIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideosByVideoIdsResponseType>,
    References.GetVideosByVideoIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByVideoIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEOS_BY_VIDEO_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideosByVideoIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideosByVideoIdsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideosByVideoIdsQueryReturn<T>;
}

type UseGetVideosByVideoIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideosByVideoIdsResponseType>,
    References.GetVideosByVideoIdsRequestType,
    T extends true
      ? Record<
          'getVideosByVideoIds',
          References.GetVideosByVideoIdsResponseType
        >
      : References.GetVideosByVideoIdsResponseType
  >;

export function useGetVideosByVideoIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideosByVideoIdsResponseType>,
    References.GetVideosByVideoIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByVideoIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEOS_BY_VIDEO_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideosByVideoIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideosByVideoIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideosByVideoIdsLazyQueryReturn<T>;
}

type UseGetVideosByVideoIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetVideosByVideoIdsResponseType>,
    References.GetVideosByVideoIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getVideosByVideoIds', References.GetVideosByVideoIdsResponseType>
    : References.GetVideosByVideoIdsResponseType;
};

export function useGetVideosByVideoIdsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideosByVideoIdsResponseType>,
    References.GetVideosByVideoIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByVideoIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEOS_BY_VIDEO_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideosByVideoIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideosByVideoIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideosByVideoIdsSuspenseQueryReturn<T>;
}

type UseGetVideoByFileIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetVideoByFileIdResponseType>,
    References.GetVideoByFileIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getVideoByFileId', References.GetVideoByFileIdResponseType>
        : References.GetVideoByFileIdResponseType)
    | undefined;
};

export function useGetVideoByFileIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideoByFileIdResponseType>,
    References.GetVideoByFileIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByFileIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEO_BY_FILE_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoByFileId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoByFileIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetVideoByFileIdQueryReturn<T>;
}

type UseGetVideoByFileIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideoByFileIdResponseType>,
    References.GetVideoByFileIdRequestType,
    T extends true
      ? Record<'getVideoByFileId', References.GetVideoByFileIdResponseType>
      : References.GetVideoByFileIdResponseType
  >;

export function useGetVideoByFileIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideoByFileIdResponseType>,
    References.GetVideoByFileIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByFileIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEO_BY_FILE_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoByFileId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideoByFileIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideoByFileIdLazyQueryReturn<T>;
}

type UseGetVideoByFileIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetVideoByFileIdResponseType>,
    References.GetVideoByFileIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getVideoByFileId', References.GetVideoByFileIdResponseType>
    : References.GetVideoByFileIdResponseType;
};

export function useGetVideoByFileIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideoByFileIdResponseType>,
    References.GetVideoByFileIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByFileIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEO_BY_FILE_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideoByFileId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoByFileIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideoByFileIdSuspenseQueryReturn<T>;
}

type UseGetVideosByFileIdsBulkQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetVideosByFileIdsBulkResponseType>,
    References.GetVideosByFileIdsBulkRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getVideosByFileIdsBulk',
            References.GetVideosByFileIdsBulkResponseType
          >
        : References.GetVideosByFileIdsBulkResponseType)
    | undefined;
};

export function useGetVideosByFileIdsBulkQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideosByFileIdsBulkResponseType>,
    References.GetVideosByFileIdsBulkRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByFileIdsBulkQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEOS_BY_FILE_IDS_BULK_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideosByFileIdsBulk: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideosByFileIdsBulkQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideosByFileIdsBulkQueryReturn<T>;
}

type UseGetVideosByFileIdsBulkLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideosByFileIdsBulkResponseType>,
    References.GetVideosByFileIdsBulkRequestType,
    T extends true
      ? Record<
          'getVideosByFileIdsBulk',
          References.GetVideosByFileIdsBulkResponseType
        >
      : References.GetVideosByFileIdsBulkResponseType
  >;

export function useGetVideosByFileIdsBulkLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideosByFileIdsBulkResponseType>,
    References.GetVideosByFileIdsBulkRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByFileIdsBulkLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEOS_BY_FILE_IDS_BULK_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideosByFileIdsBulk: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideosByFileIdsBulkLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideosByFileIdsBulkLazyQueryReturn<T>;
}

type UseGetVideosByFileIdsBulkSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetVideosByFileIdsBulkResponseType>,
    References.GetVideosByFileIdsBulkRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getVideosByFileIdsBulk',
        References.GetVideosByFileIdsBulkResponseType
      >
    : References.GetVideosByFileIdsBulkResponseType;
};

export function useGetVideosByFileIdsBulkSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideosByFileIdsBulkResponseType>,
    References.GetVideosByFileIdsBulkRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByFileIdsBulkSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEOS_BY_FILE_IDS_BULK_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideosByFileIdsBulk: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideosByFileIdsBulkSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideosByFileIdsBulkSuspenseQueryReturn<T>;
}

type UseGetVideosByFileIdsPagedQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetVideosByFileIdsPagedResponseType>,
    References.GetVideosByFileIdsPagedRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getVideosByFileIdsPaged',
            References.GetVideosByFileIdsPagedResponseType
          >
        : References.GetVideosByFileIdsPagedResponseType)
    | undefined;
};

export function useGetVideosByFileIdsPagedQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideosByFileIdsPagedResponseType>,
    References.GetVideosByFileIdsPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByFileIdsPagedQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEOS_BY_FILE_IDS_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideosByFileIdsPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideosByFileIdsPagedQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideosByFileIdsPagedQueryReturn<T>;
}

type UseGetVideosByFileIdsPagedLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideosByFileIdsPagedResponseType>,
    References.GetVideosByFileIdsPagedRequestType,
    T extends true
      ? Record<
          'getVideosByFileIdsPaged',
          References.GetVideosByFileIdsPagedResponseType
        >
      : References.GetVideosByFileIdsPagedResponseType
  >;

export function useGetVideosByFileIdsPagedLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideosByFileIdsPagedResponseType>,
    References.GetVideosByFileIdsPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByFileIdsPagedLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEOS_BY_FILE_IDS_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideosByFileIdsPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideosByFileIdsPagedLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideosByFileIdsPagedLazyQueryReturn<T>;
}

type UseGetVideosByFileIdsPagedSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetVideosByFileIdsPagedResponseType>,
    References.GetVideosByFileIdsPagedRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getVideosByFileIdsPaged',
        References.GetVideosByFileIdsPagedResponseType
      >
    : References.GetVideosByFileIdsPagedResponseType;
};

export function useGetVideosByFileIdsPagedSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideosByFileIdsPagedResponseType>,
    References.GetVideosByFileIdsPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideosByFileIdsPagedSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEOS_BY_FILE_IDS_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideosByFileIdsPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideosByFileIdsPagedSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideosByFileIdsPagedSuspenseQueryReturn<T>;
}

type UseGetVideoByCrmIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetVideoByCrmIdResponseType>,
    References.GetVideoByCrmIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getVideoByCrmId', References.GetVideoByCrmIdResponseType>
        : References.GetVideoByCrmIdResponseType)
    | undefined;
};

export function useGetVideoByCrmIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideoByCrmIdResponseType>,
    References.GetVideoByCrmIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByCrmIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEO_BY_CRM_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoByCrmId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoByCrmIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetVideoByCrmIdQueryReturn<T>;
}

type UseGetVideoByCrmIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideoByCrmIdResponseType>,
    References.GetVideoByCrmIdRequestType,
    T extends true
      ? Record<'getVideoByCrmId', References.GetVideoByCrmIdResponseType>
      : References.GetVideoByCrmIdResponseType
  >;

export function useGetVideoByCrmIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideoByCrmIdResponseType>,
    References.GetVideoByCrmIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByCrmIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEO_BY_CRM_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoByCrmId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideoByCrmIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideoByCrmIdLazyQueryReturn<T>;
}

type UseGetVideoByCrmIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetVideoByCrmIdResponseType>,
    References.GetVideoByCrmIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getVideoByCrmId', References.GetVideoByCrmIdResponseType>
    : References.GetVideoByCrmIdResponseType;
};

export function useGetVideoByCrmIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideoByCrmIdResponseType>,
    References.GetVideoByCrmIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoByCrmIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEO_BY_CRM_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideoByCrmId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoByCrmIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideoByCrmIdSuspenseQueryReturn<T>;
}

type UseSoftDeleteVideoByFileIdMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SoftDeleteVideoByFileIdResponseType>,
    References.SoftDeleteVideoByFileIdRequestType,
    T extends true
      ? Record<
          'softDeleteVideoByFileId',
          References.SoftDeleteVideoByFileIdResponseType
        >
      : References.SoftDeleteVideoByFileIdResponseType
  >;

export function useSoftDeleteVideoByFileIdMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SoftDeleteVideoByFileIdResponseType>,
    References.SoftDeleteVideoByFileIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSoftDeleteVideoByFileIdMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SOFT_DELETE_VIDEO_BY_FILE_ID_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            softDeleteVideoByFileId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSoftDeleteVideoByFileIdMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSoftDeleteVideoByFileIdMutationReturn<T>;
}

type UseSoftDeleteVideosByFileIdsBulkMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SoftDeleteVideosByFileIdsBulkResponseType>,
    References.SoftDeleteVideosByFileIdsBulkRequestType,
    T extends true
      ? Record<
          'softDeleteVideosByFileIdsBulk',
          References.SoftDeleteVideosByFileIdsBulkResponseType
        >
      : References.SoftDeleteVideosByFileIdsBulkResponseType
  >;

export function useSoftDeleteVideosByFileIdsBulkMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.SoftDeleteVideosByFileIdsBulkResponseType>,
    References.SoftDeleteVideosByFileIdsBulkRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSoftDeleteVideosByFileIdsBulkMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SOFT_DELETE_VIDEOS_BY_FILE_IDS_BULK_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            softDeleteVideosByFileIdsBulk: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSoftDeleteVideosByFileIdsBulkMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSoftDeleteVideosByFileIdsBulkMutationReturn<T>;
}

type UseHardDeleteVideoByFileIdMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.HardDeleteVideoByFileIdResponseType>,
    References.HardDeleteVideoByFileIdRequestType,
    T extends true
      ? Record<
          'hardDeleteVideoByFileId',
          References.HardDeleteVideoByFileIdResponseType
        >
      : References.HardDeleteVideoByFileIdResponseType
  >;

export function useHardDeleteVideoByFileIdMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.HardDeleteVideoByFileIdResponseType>,
    References.HardDeleteVideoByFileIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseHardDeleteVideoByFileIdMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.HARD_DELETE_VIDEO_BY_FILE_ID_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            hardDeleteVideoByFileId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseHardDeleteVideoByFileIdMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseHardDeleteVideoByFileIdMutationReturn<T>;
}

type UseUpdateVideoByFileIdMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateVideoByFileIdResponseType>,
    References.UpdateVideoByFileIdRequestType,
    T extends true
      ? Record<
          'updateVideoByFileId',
          References.UpdateVideoByFileIdResponseType
        >
      : References.UpdateVideoByFileIdResponseType
  >;

export function useUpdateVideoByFileIdMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateVideoByFileIdResponseType>,
    References.UpdateVideoByFileIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateVideoByFileIdMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_VIDEO_BY_FILE_ID_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateVideoByFileId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateVideoByFileIdMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateVideoByFileIdMutationReturn<T>;
}

type UseSetThumbnailMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.SetThumbnailResponseType>,
  References.SetThumbnailRequestType,
  T extends true
    ? Record<'setThumbnail', References.SetThumbnailResponseType>
    : References.SetThumbnailResponseType
>;

export function useSetThumbnailMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SetThumbnailResponseType>,
    References.SetThumbnailRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetThumbnailMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_THUMBNAIL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setThumbnail: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetThumbnailMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetThumbnailMutationReturn<T>;
}

type UseSetThumbnailV2MutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.SetThumbnailV2ResponseType>,
  References.SetThumbnailV2RequestType,
  T extends true
    ? Record<'setThumbnailV2', References.SetThumbnailV2ResponseType>
    : References.SetThumbnailV2ResponseType
>;

export function useSetThumbnailV2Mutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.SetThumbnailV2ResponseType>,
    References.SetThumbnailV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSetThumbnailV2MutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SET_THUMBNAIL_V2_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            setThumbnailV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSetThumbnailV2MutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSetThumbnailV2MutationReturn<T>;
}

type UseUpdateVideoEmbeddabilityMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateVideoEmbeddabilityResponseType>,
    References.UpdateVideoEmbeddabilityRequestType,
    T extends true
      ? Record<
          'updateVideoEmbeddability',
          References.UpdateVideoEmbeddabilityResponseType
        >
      : References.UpdateVideoEmbeddabilityResponseType
  >;

export function useUpdateVideoEmbeddabilityMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateVideoEmbeddabilityResponseType>,
    References.UpdateVideoEmbeddabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateVideoEmbeddabilityMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_VIDEO_EMBEDDABILITY_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateVideoEmbeddability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateVideoEmbeddabilityMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateVideoEmbeddabilityMutationReturn<T>;
}

type UseUpdateVideoVisibilityMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateVideoVisibilityResponseType>,
    References.UpdateVideoVisibilityRequestType,
    T extends true
      ? Record<
          'updateVideoVisibility',
          References.UpdateVideoVisibilityResponseType
        >
      : References.UpdateVideoVisibilityResponseType
  >;

export function useUpdateVideoVisibilityMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateVideoVisibilityResponseType>,
    References.UpdateVideoVisibilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateVideoVisibilityMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_VIDEO_VISIBILITY_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateVideoVisibility: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateVideoVisibilityMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateVideoVisibilityMutationReturn<T>;
}

type UseGetVideoLimitInfoQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetVideoLimitInfoResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getVideoLimitInfo', References.GetVideoLimitInfoResponseType>
        : References.GetVideoLimitInfoResponseType)
    | undefined;
};

export function useGetVideoLimitInfoQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideoLimitInfoResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoLimitInfoQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEO_LIMIT_INFO_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoLimitInfo: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoLimitInfoQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetVideoLimitInfoQueryReturn<T>;
}

type UseGetVideoLimitInfoLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideoLimitInfoResponseType>,
    {},
    T extends true
      ? Record<'getVideoLimitInfo', References.GetVideoLimitInfoResponseType>
      : References.GetVideoLimitInfoResponseType
  >;

export function useGetVideoLimitInfoLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideoLimitInfoResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoLimitInfoLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEO_LIMIT_INFO_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoLimitInfo: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideoLimitInfoLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideoLimitInfoLazyQueryReturn<T>;
}

type UseGetVideoLimitInfoSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetVideoLimitInfoResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getVideoLimitInfo', References.GetVideoLimitInfoResponseType>
    : References.GetVideoLimitInfoResponseType;
};

export function useGetVideoLimitInfoSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideoLimitInfoResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoLimitInfoSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEO_LIMIT_INFO_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideoLimitInfo: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoLimitInfoSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideoLimitInfoSuspenseQueryReturn<T>;
}

type UseGetVideoLimitInfoForDisplayQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetVideoLimitInfoForDisplayResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getVideoLimitInfoForDisplay',
            References.GetVideoLimitInfoForDisplayResponseType
          >
        : References.GetVideoLimitInfoForDisplayResponseType)
    | undefined;
};

export function useGetVideoLimitInfoForDisplayQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetVideoLimitInfoForDisplayResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoLimitInfoForDisplayQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoLimitInfoForDisplay: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoLimitInfoForDisplayQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideoLimitInfoForDisplayQueryReturn<T>;
}

type UseGetVideoLimitInfoForDisplayLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetVideoLimitInfoForDisplayResponseType>,
    {},
    T extends true
      ? Record<
          'getVideoLimitInfoForDisplay',
          References.GetVideoLimitInfoForDisplayResponseType
        >
      : References.GetVideoLimitInfoForDisplayResponseType
  >;

export function useGetVideoLimitInfoForDisplayLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetVideoLimitInfoForDisplayResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoLimitInfoForDisplayLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getVideoLimitInfoForDisplay: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetVideoLimitInfoForDisplayLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetVideoLimitInfoForDisplayLazyQueryReturn<T>;
}

type UseGetVideoLimitInfoForDisplaySuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetVideoLimitInfoForDisplayResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getVideoLimitInfoForDisplay',
          References.GetVideoLimitInfoForDisplayResponseType
        >
      : References.GetVideoLimitInfoForDisplayResponseType;
  };

export function useGetVideoLimitInfoForDisplaySuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetVideoLimitInfoForDisplayResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetVideoLimitInfoForDisplaySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getVideoLimitInfoForDisplay: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetVideoLimitInfoForDisplaySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetVideoLimitInfoForDisplaySuspenseQueryReturn<T>;
}

type UseGetOrCreateShareKeyMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.GetOrCreateShareKeyResponseType>,
    References.GetOrCreateShareKeyRequestType,
    T extends true
      ? Record<
          'getOrCreateShareKey',
          References.GetOrCreateShareKeyResponseType
        >
      : References.GetOrCreateShareKeyResponseType
  >;

export function useGetOrCreateShareKeyMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.GetOrCreateShareKeyResponseType>,
    References.GetOrCreateShareKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOrCreateShareKeyMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.GET_OR_CREATE_SHARE_KEY_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOrCreateShareKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetOrCreateShareKeyMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetOrCreateShareKeyMutationReturn<T>;
}

type UseDeleteShareKeyMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.DeleteShareKeyResponseType>,
  References.DeleteShareKeyRequestType,
  T extends true
    ? Record<'deleteShareKey', References.DeleteShareKeyResponseType>
    : References.DeleteShareKeyResponseType
>;

export function useDeleteShareKeyMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteShareKeyResponseType>,
    References.DeleteShareKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteShareKeyMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_SHARE_KEY_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteShareKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteShareKeyMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteShareKeyMutationReturn<T>;
}

type UseResolveShareKeyQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ResolveShareKeyResponseType>,
    References.ResolveShareKeyRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'resolveShareKey', References.ResolveShareKeyResponseType>
        : References.ResolveShareKeyResponseType)
    | undefined;
};

export function useResolveShareKeyQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ResolveShareKeyResponseType>,
    References.ResolveShareKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveShareKeyQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.RESOLVE_SHARE_KEY_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            resolveShareKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseResolveShareKeyQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseResolveShareKeyQueryReturn<T>;
}

type UseResolveShareKeyLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ResolveShareKeyResponseType>,
    References.ResolveShareKeyRequestType,
    T extends true
      ? Record<'resolveShareKey', References.ResolveShareKeyResponseType>
      : References.ResolveShareKeyResponseType
  >;

export function useResolveShareKeyLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ResolveShareKeyResponseType>,
    References.ResolveShareKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveShareKeyLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.RESOLVE_SHARE_KEY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            resolveShareKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseResolveShareKeyLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseResolveShareKeyLazyQueryReturn<T>;
}

type UseResolveShareKeySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ResolveShareKeyResponseType>,
    References.ResolveShareKeyRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'resolveShareKey', References.ResolveShareKeyResponseType>
    : References.ResolveShareKeyResponseType;
};

export function useResolveShareKeySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ResolveShareKeyResponseType>,
    References.ResolveShareKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseResolveShareKeySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.RESOLVE_SHARE_KEY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            resolveShareKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseResolveShareKeySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseResolveShareKeySuspenseQueryReturn<T>;
}

type UseGetSignedTranscriptsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSignedTranscriptsResponseType>,
    References.GetSignedTranscriptsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getSignedTranscripts',
            References.GetSignedTranscriptsResponseType
          >
        : References.GetSignedTranscriptsResponseType)
    | undefined;
};

export function useGetSignedTranscriptsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSignedTranscriptsResponseType>,
    References.GetSignedTranscriptsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSignedTranscriptsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_SIGNED_TRANSCRIPTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSignedTranscripts: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSignedTranscriptsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSignedTranscriptsQueryReturn<T>;
}

type UseGetSignedTranscriptsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSignedTranscriptsResponseType>,
    References.GetSignedTranscriptsRequestType,
    T extends true
      ? Record<
          'getSignedTranscripts',
          References.GetSignedTranscriptsResponseType
        >
      : References.GetSignedTranscriptsResponseType
  >;

export function useGetSignedTranscriptsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSignedTranscriptsResponseType>,
    References.GetSignedTranscriptsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSignedTranscriptsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SIGNED_TRANSCRIPTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSignedTranscripts: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSignedTranscriptsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSignedTranscriptsLazyQueryReturn<T>;
}

type UseGetSignedTranscriptsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSignedTranscriptsResponseType>,
    References.GetSignedTranscriptsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getSignedTranscripts',
        References.GetSignedTranscriptsResponseType
      >
    : References.GetSignedTranscriptsResponseType;
};

export function useGetSignedTranscriptsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSignedTranscriptsResponseType>,
    References.GetSignedTranscriptsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSignedTranscriptsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SIGNED_TRANSCRIPTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSignedTranscripts: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSignedTranscriptsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSignedTranscriptsSuspenseQueryReturn<T>;
}

type UseGetPreviewPlayerQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetPreviewPlayerResponseType>,
    References.GetPreviewPlayerRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getPreviewPlayer', References.GetPreviewPlayerResponseType>
        : References.GetPreviewPlayerResponseType)
    | undefined;
};

export function useGetPreviewPlayerQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetPreviewPlayerResponseType>,
    References.GetPreviewPlayerRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPreviewPlayerQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_PREVIEW_PLAYER_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPreviewPlayer: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPreviewPlayerQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetPreviewPlayerQueryReturn<T>;
}

type UseGetPreviewPlayerLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPreviewPlayerResponseType>,
    References.GetPreviewPlayerRequestType,
    T extends true
      ? Record<'getPreviewPlayer', References.GetPreviewPlayerResponseType>
      : References.GetPreviewPlayerResponseType
  >;

export function useGetPreviewPlayerLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPreviewPlayerResponseType>,
    References.GetPreviewPlayerRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPreviewPlayerLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PREVIEW_PLAYER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPreviewPlayer: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPreviewPlayerLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPreviewPlayerLazyQueryReturn<T>;
}

type UseGetPreviewPlayerSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetPreviewPlayerResponseType>,
    References.GetPreviewPlayerRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getPreviewPlayer', References.GetPreviewPlayerResponseType>
    : References.GetPreviewPlayerResponseType;
};

export function useGetPreviewPlayerSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPreviewPlayerResponseType>,
    References.GetPreviewPlayerRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPreviewPlayerSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PREVIEW_PLAYER_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPreviewPlayer: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPreviewPlayerSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPreviewPlayerSuspenseQueryReturn<T>;
}
